import React from 'react';
import { CareerGuidance2026 } from '../views';


const BridgeCoursePage = () => {
  return <CareerGuidance2026/>;
};

export default BridgeCoursePage;